import React from 'react';
import Button from '../button/button';
import classNames from 'classnames';
import { buildVersionedClass } from '@op/opds.opux-utilities';
import { IconNext, IconLast } from '@op/opds.opux-icons/navigation';
/**
 * Last two buttons in pagination component.
 * Renders button 'last' that changes pagination page to the last one.
 * Also renders button 'next' that changes pagination page to the next one.
 */
const LastAndNextButtons = _ref => {
  let {
    activePageIndex,
    arrowControls,
    dispatchWithPageCount,
    hideSegments,
    lastButtonLabel,
    nextButtonLabel,
    pageCount,
    size
  } = _ref;
  if (arrowControls === 'none') {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: buildVersionedClass('ds-pagination__button-container')
  }, (arrowControls === 'all' || arrowControls === 'prevNext') && /*#__PURE__*/React.createElement(Button, {
    className: classNames({
      [buildVersionedClass('ds-pagination__button-container__next--no-page-controls')]: hideSegments
    }),
    compact: size === 'small',
    disabled: activePageIndex === pageCount - 1,
    href: "#!",
    icon: IconNext,
    iconLabel: nextButtonLabel,
    minified: true,
    onClick: event => {
      event.preventDefault();
      dispatchWithPageCount({
        type: 'NEXT'
      });
    },
    size: size !== 'small' ? size : 'default'
  }), arrowControls === 'all' && /*#__PURE__*/React.createElement(Button, {
    compact: size === 'small',
    disabled: activePageIndex === pageCount - 1,
    href: "#!",
    icon: IconLast,
    iconLabel: lastButtonLabel,
    minified: true,
    onClick: event => {
      event.preventDefault();
      dispatchWithPageCount({
        type: 'LAST'
      });
    },
    size: size !== 'small' ? size : 'default'
  }));
};
export default LastAndNextButtons;